// import React, { useState, useCallback } from 'react'
import React from 'react'
import { useTransition, animated } from 'react-spring'
import cssCard from './Card.module.scss';

// Sample Code:
// https://codesandbox.io/embed/1y3yyqpq7q
// 如何在 Class compoment 使用 Hook
// https://hellocode.dev/using-hooks-with-classes

function ReactSpringRightToLeft(props) {
    console.log("ReactSpringRightToLeft")
    console.log("ReactSpring.props: ", props)

        // 動畫 由右而左
        const TransitionArray = useTransition(props.Index, p => p, {
            from: { opacity: 0, transform: 'translate3d(50%,0,0)' },
            enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
            leave: { opacity: 0, transform: 'translate3d(-100%,0,0)' },
        })

        console.log("TransitionArray: ", TransitionArray)

    return props.children({ TransitionArray });
}

function ReactSpringLeftToRight(props) {
    console.log("ReactSpringLeftToRight")
    console.log("ReactSpring.props: ", props)

        // 動畫 由左而右
        const TransitionArray = useTransition(props.Index, p => p, {
            from: { opacity: 0, transform: 'translate3d(-50%,0,0)' },
            enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
            leave: { opacity: 0, transform: 'translate3d(100%,0,0)' },
        })

        console.log("TransitionArray: ", TransitionArray)

    return props.children({ TransitionArray });
}

function ReactSpringWithoutAnimation(props) {
    console.log("ReactSpringWithoutAnimation")
    console.log("ReactSpring.props: ", props)

    // 無動畫
    const TransitionArray = useTransition(props.Index, p => p, {
        from: { opacity: 1, transform: 'translate3d(0%,0,0)' },
        enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
        leave: { opacity: 1, transform: 'translate3d(0%,0,0)' },
    })

    console.log("TransitionArray: ", TransitionArray)

    return props.children({ TransitionArray });
}

export const CardBackgroundEnum = {
	"Default": 1,
    "GrayWithRadius": 2
}

const COMP_NAME = "Card"
class Card extends React.Component 
{
    constructor(props)
    {
        super(props)

        console.log(COMP_NAME + ".constructor: ", this.props)
        console.log(COMP_NAME + "this.props.CardIndex: ", parseInt(this.props.CardIndex))
        console.log(COMP_NAME + "this.props.ChangeAnimationType: ", this.props.ChangeAnimationType)
        console.log(COMP_NAME + "this.props.RenderContent: ", this.props.RenderContent)

        // this.props.CallbackRef
        
        this.state = {
            // Index: 1
            Index: parseInt(this.props.CardIndex)
        }
        this.GetClsCardBackground = this.GetClsCardBackground.bind(this)
        this.ClickHandler = this.ClickHandler.bind(this)
        this.GetPage = this.GetPage.bind(this)

    } // end of constructor


    componentDidMount()
    {
        console.log(COMP_NAME + ".componentDidMount")
        if(
            (typeof(this.props.CallbackRef) !== "undefined") &&
            (this.props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "ComponentDidMount"
            }
            this.props.CallbackRef(objCallbackData)
        }
    }


    componentWillUnmount()
    {
        console.log(COMP_NAME + ".componentWillUnmount")
    }

    componentDidUpdate() {
        console.log(COMP_NAME + ".componentDidUpdate")

        if(
            (typeof(this.props.CallbackRef) !== "undefined") &&
            (this.props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "ComponentDidUpdate"
            }
            this.props.CallbackRef(objCallbackData)
        }
    }

    ClickHandler()
    {
        console.log(COMP_NAME + ".ClickHandler");
        console.log("ClickHandler: this.state.Index:", this.state.Index);

        this.setState({
            // Index: (this.state.Index + 1) % 3
            Index: parseInt(this.props.CardIndex)
        })
    }

    GetClsCardBackground()
    {
        console.log(COMP_NAME + ".GetClsCardBackground");

        let objCls = cssCard.divCardBackgroundDefault
        console.log("this.props.CardBackground: ", this.props.CardBackground)
        if(
            (typeof(this.props.CardBackground) !== "undefined") &&
            (this.props.CardBackground !== null)
        )
        {
            if(this.props.CardBackground === CardBackgroundEnum.Default)
            {
                console.log("CardStyleDefault")
                objCls = cssCard.divCardBackgroundDefault
            }
            else if(this.props.CardBackground === CardBackgroundEnum.GrayWithRadius)
            {
                console.log("CardStyleCardBackgroundGrayWithRadius")
                objCls = cssCard.divCardBackgroundGrayWithRadius
            }
            else {
                objCls = cssCard.divCardBackgroundDefault
            }
        }
        return objCls
    }

    GetPage(Index, style, key)
    {
        console.log(COMP_NAME + ".GetPage");

        let objDivContent = this.props.RenderContent
        // console.log("objDivContent: ", objDivContent)
            
        return (
            <animated.div key={key} className={this.GetClsCardBackground()} style={{ ...style}}>{objDivContent}</animated.div>
        )
    }

    render()
    {
        if ( parseInt(this.props.ChangeAnimationType) === window.gChangeAnimationTypeEnum.Next) {
            return (
                <ReactSpringRightToLeft Index={parseInt(this.props.CardIndex)}>
                {
                    ({ TransitionArray }) => {

                        console.log("TransitionArray: ", TransitionArray)
                        return(
                            /*<div className={cssCard.simpletransmain} onClick={this.ClickHandler}>*/
                            <div className={cssCard.simpletransmain} onClick={this.ClickHandler}>
                                {TransitionArray.map(({ item, props, key }) => {
                                    return this.GetPage(parseInt(this.props.CardIndex), props, key)
                                })}
                            </div>
                        )
                    }
                }
                </ReactSpringRightToLeft>
            )
        }
        else if ( parseInt(this.props.ChangeAnimationType) === window.gChangeAnimationTypeEnum.Prev ) {
            return (
                <ReactSpringLeftToRight Index={parseInt(this.props.CardIndex)}>
                {
                    ({ TransitionArray }) => {

                        console.log("TransitionArray: ", TransitionArray)
                        return(

                            /*<div className={cssCard.simpletransmain} onClick={this.ClickHandler}>*/
                            <div className={cssCard.simpletransmain}>
                                {TransitionArray.map(({ item, props, key }) => {
                                    return this.GetPage(parseInt(this.props.CardIndex), props, key)
                                })}
                            </div>

                        )
                    }
                }
                </ReactSpringLeftToRight>
            )
        }
        else {
            return (
                <ReactSpringWithoutAnimation Index={parseInt(this.props.CardIndex)}>
                {
                    ({ TransitionArray }) => {

                        console.log("TransitionArray: ", TransitionArray)
                        return(

                            /*<div className={cssCard.simpletransmain} onClick={this.ClickHandler}>*/
                            <div className={cssCard.simpletransmain}>
                                {TransitionArray.map(({ item, props, key }) => {
                                    return this.GetPage(parseInt(this.props.CardIndex), props, key)
                                })}
                            </div>

                        )
                    }
                }
                </ReactSpringWithoutAnimation>
            )
        }
        
    }

}

export default Card


